import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FormControl, FormLabel, StyleProps, Switch } from '@bonusly/design-system';

import { useActionInput } from '../../context';
import { useActionData, useIsEnabled } from '../../hooks';

type GiverToggleProps = StyleProps;

export const GiverToggle: FC<GiverToggleProps> = (props) => {
	const { t } = useTranslation('action_input');
	const isEnabled = useIsEnabled('include-giver');
	const { includeGiver, setIncludeGiver } = useActionInput();
	const data = useActionData();

	if (!isEnabled || !data.amount) {
		return null;
	}

	return (
		<FormControl display="flex" alignItems="center" {...props}>
			<Switch id="include-giver" isChecked={includeGiver} onChange={(e) => setIncludeGiver(e.target.checked)} />
			<FormLabel htmlFor="include-giver" fontSize="sm" fontWeight="medium" m={0} ml={2}>
				{t('include_giver')}
			</FormLabel>
		</FormControl>
	);
};
